export const Errors: { [k: string]: any } = {
  LIMIT_RESEND_OTP: "You can only receive a maximum of 5 OTPs per day",
  OTP_NOT_EXIST_OR_EXPIRE: "OTP does not exist or has expired. Please try again.",
  SEND_OTP_ERROR:
    "Failed to send OTP. Please check your phone number and try again.",
  VERIFY_OTP_ERROR:
    "OTP verification failed. Please check your OTP and try again.",
  USERNAME_EXISTED: "This username is already taken. Please try another.",
  PROFILE_UPDATED_ERROR: "Profile update failed. Please try again.",
  MAXIMUM_LUCKY_NUMBER_CAN_SELECTED: "You have reached the maximum number of selections.",
  UNKNOWN: "Something went wrong. Please try again.",
  SUBMIT: "Submission failed. Please try again.",
  FAILED_TO_SUBMIT_RAFFLE: "Failed to submit raffle entry. Please try again.",
};
